
import { Provider } from 'mobx-react'

import { inject, observer } from "mobx-react"
import { computed } from "mobx"

import appStore from './stores/appStore';
import mainStore from './stores/mainStore';

import NotFound from '../src/NotFound';
import Router from './Router';

import Loader from '@Common/Loader';

import { YMInitializer } from "react-yandex-metrika"

const { MODE } = import.meta.env;

const stores = {
    appStore,
    mainStore,
};

const Root = inject('mainStore')(observer(({ mainStore }) => {
    const initialApp = computed(() => mainStore.getMainStore("initialApp")).get();
    const isNotFound = computed(() => mainStore.getMainStore("isNotFound")).get();

    const init = computed(() => mainStore.getMainStore("init")).get();
    // console.log('env', import.meta.env);
    // console.log(MODE);


    const Specified = isNotFound ? NotFound : initialApp == 'complete' ? Router : initialApp == 'loading' ? Loader : () => null

    return <Specified />
}))

const ProvideStore = () => {
    return (
        <>
            <YMInitializer
                accounts={MODE === 'production' ? [95339074] : [96976906]}
                version='2'
                options={{
                    clickmap: true,
                    trackLinks: true,
                    accurateTrackBounce: true,
                    webvisor: true,
                    trackHash: true,
                }}
            />
            <Provider {...stores}>
                <Root />
            </Provider>
        </>
    )
}

export default ProvideStore